import React from 'react';
import {Form, Input} from "antd";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import {LANGS} from "../marketCourse.utils";

/**
 * Текстовое поле-триплет {ru, kk, en} с одним общим переключателем языка на всю форму.
 *
 * Все три языка смонтированы одновременно, неактивные скрыты стилем, а не размонтированы.
 * Две причины:
 *   1) значения не теряются и не «мигают» при переключении вкладки;
 *   2) правило required на русском срабатывает, даже когда открыта вкладка ҚАЗ или ENG —
 *      у размонтированного Form.Item правил в форме уже нет, и пустое обязательное поле
 *      молча уехало бы на бэкенд.
 *
 * @param name      путь до триплета: 'title' или ['trainer', 'name'], внутри Form.List — [field.name, 'title']
 * @param label     подпись поля
 * @param lang      активный язык (состояние формы, общее для всех полей)
 * @param rows      если задано — многострочный ввод на столько строк
 * @param required  обязательность; проверяем только русский, kk и en заказчик заполняет по мере перевода
 */
const LocalizedInput = ({name, label, lang, rows, required = false}) => {
    const path = Array.isArray(name) ? name : [name];

    return (
        <>
            {LANGS.map(({code}) => (
                <div key={code} style={{display: code === lang ? 'block' : 'none'}}>
                    <Form.Item
                        name={[...path, code]}
                        label={label}
                        style={{marginBottom: 12}}
                        rules={required && code === 'ru'
                            ? [{
                                required: true,
                                whitespace: true,
                                message: <IntlMessage id={'marketCoursesPage.requiredRu'}/>,
                            }]
                            : undefined}
                    >
                        {rows ? <Input.TextArea rows={rows} autoSize={{minRows: rows}}/> : <Input/>}
                    </Form.Item>
                </div>
            ))}
        </>
    );
};

export default LocalizedInput;
